import { getAppointmentStatus, usePermanentLocations } from "components";
import { NotificationContainer } from "components/NotificationsCenter/components/ClaireNotification/components/NotificationContainer";
import { STATUS_IDENTIFIERS } from "models";

import type { NotificationRegistryConfig } from "components";
import type { Appointment } from "models";

type AppointmentStatusNotificationProps = {
  appointment: Appointment;
  icon: string;
  title?: string;
  description?: string;
  closeToast: () => void;
};

export const AppointmentStatusNotification = ({ icon, appointment, description, closeToast }: AppointmentStatusNotificationProps) => {
  const { locations } = usePermanentLocations();

  const dealerLocation = locations.find(loc => loc.id === appointment.dealer_location_id);
  const status = getAppointmentStatus(STATUS_IDENTIFIERS.CarInShop, dealerLocation?.statuses);

  return <NotificationContainer icon={icon} title={status.name} description={description} onCloseNotification={closeToast} />;
};

export const AppointmentStatusNotificationConfig: NotificationRegistryConfig = {
  toastOptions: { style: { width: "450px", right: "130px" } },
  render: ({ closeToast, icon, appointment, description }) =>
    appointment ? <AppointmentStatusNotification icon={icon} appointment={appointment} description={description} closeToast={closeToast} /> : null
};
